import {md2html} from '@github-ui/md2html'
import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {
  updateIssueBodyMutation,
  updateIssueBodyMutation$data,
  UpdateIssueInput,
} from './__generated__/updateIssueBodyMutation.graphql'

type commitUpdateIssueBodyMutationProps = {
  environment: Environment
  input: {
    issueId: string
    body: string
    tasklistBlocksOperation?: string | null
    bodyVersion: string
  }
  onCompleted?: (response: updateIssueBodyMutation$data) => void
  onError?: (error: Error) => void
  withOptimisticResponse?: boolean
}

export function commitUpdateIssueBodyMutation({
  environment,
  input: {issueId, body, tasklistBlocksOperation, bodyVersion},
  onCompleted,
  onError,
  withOptimisticResponse = false,
}: commitUpdateIssueBodyMutationProps) {
  const inputHash: UpdateIssueInput = {
    id: issueId,
    body,
    tasklistBlocksOperation,
    bodyVersion,
  }

  return commitMutation<updateIssueBodyMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation updateIssueBodyMutation($input: UpdateIssueInput!) @raw_response_type {
        updateIssue(input: $input) {
          issue {
            id
            bodyVersion
            ...IssueBodyContent
            ...MarkdownEditHistoryViewer_comment
            ...MarkdownLastEditedBy
          }
        }
      }
    `,
    optimisticResponse: withOptimisticResponse
      ? {
          updateIssue: {
            issue: {
              id: issueId,
              body,
              bodyVersion,
              bodyHTML: md2html(body),
              lastEditedAt: new Date().toISOString(),
              viewerCanReadUserContentEdits: true,
              lastUserContentEdit: null,
              __isComment: 'Issue',
            },
          },
        }
      : undefined,
    variables: {
      input: inputHash,
    },
    onCompleted: (response: updateIssueBodyMutation$data) => onCompleted && onCompleted(response),
    onError: error => onError && onError(error),
  })
}
